var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button-render',_vm._b({attrs:{"tag":"a","href":_vm.meta.href,"target":"_blank","rel":"noreferer noopener","meta":_vm.meta,"icon":_vm.icon}},'base-button-render',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }